import React from 'react';
import {
  StyleSheet,
  View,
  Text,
  TextInput,
  ScrollView,
} from './components/base_components';
import { BusyComponent, BusyOverlay } from './components/busy_component';

import Checkbox from './components/checkbox';
import Header from './components/header';
import ProgressSpinner from './components/progress_spinner';
import TextButton from './components/buttons/text_button';
import VolumeSelect from './components/volume_select';

import DeviceAdminStore from './stores/device_admin_store';
import UserStore from './stores/user_store';

const styles = StyleSheet.create({
  deviceEditScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  scroller: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  scrollInner: {
    paddingLeft: '3em',
    paddingRight: '3em',
    paddingTop: '1em',
    paddingBottom: '5em',
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    overflowY: 'scroll',
  },
  line: {
    alignSelf: 'stretch',
    height: '1px',
    backgroundColor: 'black',
  },
  topView: {
    marginTop: '1em',
    marginBottom: '1em',
    flexDirection: 'column',
  },
  topText: {
    fontSize: '1.1em',
    lineHeight: '2em',
    fontWeight: 'bold',
  },
  propValue: {
    paddingTop: '0.5em',
    paddingBottom: '0.5em',
    borderBottom: '1px solid whitesmoke',
    justifyContent: 'flex-start',
    alignItems: 'center',
    ':hover': {
      backgroundColor: 'lightblue !important',
    },
  },
  propNameText: {
    width: '15em',
    fontSize: '1.1em',
    fontWeight: 'bold',
  },
  propValueText: {
    marginRight: '2em',
    fontSize: '1.1em',
  },
  checkbox: {},
  checkboxText: {
    marginLeft: '0.4em',
    fontSize: '1.1em',
  },
  headerText: {
    marginTop: '0.5em',
    color: '#222',
    fontSize: '1.2em',
    fontWeight: 'bold',
  },
  list: {
    marginTop: '1em',
    marginBottom: '1em',
    flexDirection: 'column',
    border: '1px solid whitesmoke',
  },
  add: {
    marginTop: '1em',
  },
  text: {
    marginTop: '1em',
    color: '#222',
    fontSize: '1.2em',
    fontWeight: 'bold',
  },
  itemLine: {
    padding: '0.5em',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    ':hover': {
      backgroundColor: 'lightblue !important',
    },
  },
  value: {
    width: '20em',
  },
  itemButton: {
    height: '2em',
  },
  button: {
    marginBottom: '2em',
    width: '10em',
    height: '2em',
  },
  addVolume: {
    marginTop: '1em',
    marginBottom: '1em',
    width: '20em',
    height: '2em',
    paddingLeft: '1em',
    color: 'black',
    fontSize: '1.3em',
    fontWeight: 'bold',
    backgroundColor: '#ccc',
    borderRadius: '0.3em',
  },
  odd: {
    backgroundColor: 'transparent',
  },
  even: {
    backgroundColor: '#ddd',
  },
  editInput: {
    marginTop: '0.3em',
    marginBottom: '0.3em',
    paddingLeft: '1em',
    paddingRight: '1em',
    width: '5em',
    height: '2em',
    backgroundColor: '#eee',
    borderRadius: '0.5em',
  },
  editButton: {
    marginLeft: '2em',
    height: '2em',
  },
});

type Props = {
  match: any;
};
type State = {
  device_id: number;
  device: any;
  add_volume_id: string;
  upload_priority: string;
};

export default class DeviceEditScreen extends BusyComponent<Props, State> {
  constructor(props, context) {
    super(props, context);
    this.state = {
      device_id: parseInt(this.props.match.params.device_id),
      device: null,
      add_volume_id: '',
      upload_priority: '',
    };
  }

  componentDidMount() {
    DeviceAdminStore.addChangeListener(this._onDeviceChange);
    const { device_id } = this.state;
    DeviceAdminStore.fetch(device_id);
  }
  componentWillUmount() {
    DeviceAdminStore.removeChangeListener(this._onDeviceChange);
  }

  _onDeviceChange = () => {
    const { device_id } = this.state;
    const device = DeviceAdminStore.getDevice(device_id);
    const upload_priority = String(device.upload_priority);
    this.setState({ device, upload_priority });
  };
  _onVolumeChange = (add_volume_id) => {
    this.setState({ add_volume_id });
  };
  _onAddPress = () => {
    const { device_id, add_volume_id } = this.state;
    if (add_volume_id && this.setBusy()) {
      const opts = { device_id, volume_id: add_volume_id };
      DeviceAdminStore.addVolume(opts, (err) => {
        this.clearBusy();
        if (err) {
          window.alert('Failed to add volume to device');
        } else {
          DeviceAdminStore.fetch(device_id);
        }
      });
    }
  };
  _onDisablePress = (volume) => {
    if (this.setBusy()) {
      const { device_id } = this.state;
      const opts = { device_id, volume_id: volume.volume_id };
      DeviceAdminStore.disableVolume(opts, (err) => {
        this.clearBusy();
        if (err) {
          window.alert('Disable Volume Failed: ' + err);
        } else {
          DeviceAdminStore.fetch(device_id);
        }
      });
    }
  };
  _onEnablePress = (volume) => {
    if (this.setBusy()) {
      const { device_id } = this.state;
      const opts = { device_id, volume_id: volume.volume_id };
      DeviceAdminStore.enableVolume(opts, (err) => {
        this.clearBusy();
        if (err) {
          window.alert('Enable Volume Failed: ' + err);
        } else {
          DeviceAdminStore.fetch(device_id);
        }
      });
    }
  };
  _onCheckboxChange = (prop, value) => {
    if (this.setBusy()) {
      const { device_id } = this.state;
      const opts = { device_id, [prop]: value };
      DeviceAdminStore.updateDevice(opts, (err) => {
        this.clearBusy();
        if (err) {
          window.alert('Device Update Failed: ' + err);
        } else {
          DeviceAdminStore.fetch(device_id);
        }
      });
    }
  };
  _onPriorityChange = (upload_priority) => this.setState({ upload_priority });
  _onPrioritySave = () => {
    if (this.setBusy()) {
      const { device_id, upload_priority } = this.state;
      const opts = { device_id, upload_priority };
      DeviceAdminStore.updateDevice(opts, (err) => {
        this.clearBusy();
        if (err) {
          window.alert('Device Update Failed: ' + err);
        } else {
          DeviceAdminStore.fetch(device_id);
        }
      });
    }
  };

  render() {
    const { device, add_volume_id, upload_priority } = this.state;

    let content = null;
    if (!device) {
      content = <ProgressSpinner />;
    } else {
      const {
        device_name,
        user_name,
        org_name,
        session_list,
        device_volume_list,
        is_download_disabled,
        is_upload_disabled,
        is_disabled,
      } = device;
      let secret = null;
      if (session_list && session_list.length > 0 && UserStore.isSuperAdmin()) {
        const device_secret = String(session_list[0].device_session_key);
        secret = <PropValue name='Device Secret' value={device_secret} />;
      }

      const volumes = device_volume_list
        .sort(_sortVolume)
        .map((volume, i) => (
          <Volume
            key={i}
            volume={volume}
            odd={i % 2 === 1}
            onDisablePress={this._onDisablePress}
            onEnablePress={this._onEnablePress}
          />
        ));

      content = (
        <>
          <View style={styles.topView}>
            <PropValue name='Device' value={device_name} />
            <PropValue name='User' value={user_name} />
            <PropValue name='Org' value={org_name} />
            {secret}
            <PropCheckbox
              name='Disabled'
              prop='is_disabled'
              value={is_disabled}
              onChange={this._onCheckboxChange}
            />
            <PropEdit
              name='Upload Priority'
              value={upload_priority}
              onChange={this._onPriorityChange}
              onSave={this._onPrioritySave}
            />
          </View>
          <Line />
          <View style={styles.topView}>
            <PropCheckbox
              name='Auto-Downloads'
              prop='is_download_disabled'
              value={is_download_disabled}
              onChange={this._onCheckboxChange}
            />
            <PropCheckbox
              name='Auto-Uploads'
              prop='is_upload_disabled'
              value={is_upload_disabled}
              onChange={this._onCheckboxChange}
            />
          </View>
          <Line />
          <Text style={styles.headerText}>Volumes:</Text>
          <View style={styles.list}>{volumes}</View>
          <Text style={styles.headerText}>Add Volume:</Text>
          <VolumeSelect
            style={styles.addVolume}
            excludeList={device_volume_list}
            device={device}
            value={add_volume_id}
            onChange={this._onVolumeChange}
          />
          <TextButton
            style={styles.button}
            text='Add Volume'
            onPress={this._onAddPress}
          />
          <Line />
        </>
      );
    }
    return (
      <View style={styles.deviceEditScreen}>
        <ScrollView
          style={styles.scroller}
          contentContainerStyle={styles.scrollInner}
        >
          <Header hideOrg={true} />
          {content}
        </ScrollView>
        <BusyOverlay isBusy={this.state.is_busy} />
      </View>
    );
  }
}

function Line() {
  return <View style={styles.line} />;
}
function PropValue(props) {
  return (
    <View style={styles.propValue}>
      <Text style={styles.propNameText}>{props.name + ':'}</Text>
      <Text style={styles.propValueText}>{props.value}</Text>
    </View>
  );
}
function PropCheckbox(props) {
  const { name, prop, value, onChange } = props;
  function _onChange(new_value) {
    onChange(prop, new_value);
  }
  return (
    <View style={styles.propValue}>
      <Text style={styles.propNameText}>{name + ':'}</Text>
      <Checkbox
        style={styles.checkbox}
        textStyle={styles.checkboxText}
        text='Disabled'
        value={value}
        onChange={_onChange}
      />
    </View>
  );
}
function PropEdit(props) {
  const { name, value, onChange, onSave } = props;
  return (
    <View style={styles.propValue}>
      <Text style={styles.propNameText}>{name + ':'}</Text>
      <TextInput
        style={styles.editInput}
        value={value}
        type='number'
        onChangeText={onChange}
      />
      <TextButton style={styles.editButton} text='Save' onPress={onSave} />
    </View>
  );
}

function ItemLine(props) {
  const { style, value, onPress, buttonText } = props;

  return (
    <View style={[styles.itemLine, style]}>
      <Text style={styles.value}>{value}</Text>
      <TextButton
        style={styles.itemButton}
        text={buttonText}
        onPress={onPress}
      />
    </View>
  );
}

function Volume(props) {
  const { volume, onEnablePress, onDisablePress, odd } = props;
  const { volume_name, is_disabled } = volume;
  function _onPress() {
    if (is_disabled) {
      onEnablePress(volume);
    } else {
      onDisablePress(volume);
    }
  }
  const style = odd ? styles.odd : styles.even;
  let content = null;
  if (is_disabled) {
    content = (
      <ItemLine
        style={style}
        value={volume_name + ' (disabled)'}
        buttonText='enable'
        onPress={_onPress}
      />
    );
  } else {
    content = (
      <ItemLine
        style={style}
        value={volume_name}
        buttonText='disable'
        onPress={_onPress}
      />
    );
  }
  return content;
}
const LOCALE_OPTS = { sensitivity: 'accent' };
function _sortVolume(a, b) {
  let ret = 0;
  if (a.is_disabled !== b.is_disabled) {
    ret = b.is_disabled > a.is_disabled ? -1 : 1;
  } else {
    ret = a.volume_name.localeCompare(b.volume_name, undefined, LOCALE_OPTS);
  }
  return ret;
}
